import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createDTPMDataLog = (payload) => post(baseURL + url.DTPM_DATA_LOG, payload);
export const getDTPMDataLogDetails = (id) => get(`${baseURL + url.DTPM_DATA_LOG}/${id}`);
export const updateDTPMDataLog = (id, payload) => put(`${baseURL + url.DTPM_DATA_LOG}/${id}`, payload);
export const deleteDTPMDataLog = (id) => remove(`${baseURL + url.DTPM_DATA_LOG}/${id}`);